import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Container,
    Typography,
    Grid,
    Card,
    CardMedia,
    Box,
} from "@mui/material";

function SocialResponsibility() {
    const [socialresponsibility, setSocialresponsibility] = useState([]);

    useEffect(() => {
        axios
            .get("/files/corporate/socialResponsibility.txt")
            .then((res) => setSocialresponsibility(res.data))
            .catch((err) => console.error("Error fetching data:", err));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: { xs: "1.75rem", sm: "2.3rem", md: "3rem" },
                }}
            >
                Social Responsibility
            </Typography>

            <Grid
                container
                spacing={4}
                alignItems="flex-start"
                sx={{
                    flexDirection: { xs: "column", md: "row" },
                }}
            >
                {/* Content first on mobile, image second */}
                <Grid
                    item
                    xs={12}
                    md={7}
                    order={{ xs: 1, md: 1 }}
                    sx={{
                        width: { xs: "100%", md: "60%" },
                        textAlign: "justify",
                    }}
                >
                    {socialresponsibility &&
                        socialresponsibility.map((data, index) => (
                            <Box key={index} sx={{ mb: 3 }}>
                                {Array.isArray(data) ? (
                                    <>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: "#030366",
                                                fontWeight: "bold",
                                                mb: 1,
                                            }}
                                        >
                                            Environment
                                        </Typography>
                                        {data.map((subItem, subIndex) => (
                                            <Typography
                                                key={subIndex}
                                                variant="body1"
                                                sx={{
                                                    fontFamily: "Raleway, sans-serif",
                                                    mb: 1,
                                                    fontSize: { xs: "16px", md: "18px" },
                                                    lineHeight: 1.8,
                                                }}
                                            >
                                                {subItem}
                                            </Typography>
                                        ))}
                                    </>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontFamily: "Raleway, sans-serif",
                                            mb: 2,
                                            fontSize: { xs: "16px", md: "18px" },
                                            lineHeight: 1.8,
                                        }}
                                    >
                                        {data}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                </Grid>

                {/* Image second on desktop, below on mobile */}
                <Grid
                    item
                    xs={12}
                    md={5}
                    order={{ xs: 2, md: 2 }}
                    sx={{
                        width: { xs: "100%", md: "30%" },
                        mt: { xs: 2, md: 0 },
                    }}
                >
                    <Card
                        sx={{
                            borderRadius: 3,
                            boxShadow: 4,
                            overflow: "hidden",
                            height: { xs: 250, sm: 300, md: 350 },
                        }}
                    >
                        <CardMedia
                            component="img"
                            image="/images/social.jpg"
                            alt="Social Responsibility"
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                            }}
                        />
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}

export default SocialResponsibility;








// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     Container,
//     Typography,
//     Grid,
//     Card,
//     CardContent,
//     CardMedia,
//     Box,
// } from "@mui/material";

// function SocialResponsibility() {
//     const [socialresponsibility, setSocialresponsibility] = useState([]);

//     useEffect(() => {
//         axios
//             .get("/files/corporate/socialResponsibility.txt")
//             .then((res) => setSocialresponsibility(res.data))
//             .catch((err) => console.error("Error fetching data:", err));
//     }, []);

//     return (
//         <Container maxWidth="lg" sx={{ py: 2 }}>
//             <Typography
//                 variant="h3"
//                 align="center"
//                 gutterBottom
//                 sx={{ fontWeight: "bold", color: "#030366", mt: 7 }}
//             >
//                 Social Responsibility
//             </Typography>

//             <Grid container spacing={4} alignItems="flex-start">
//                 {/* Left Image */}
//                 <Grid item xs={12} md={5} sx={{ width: "30%" }}>
//                     <Card
//                         sx={{
//                             borderRadius: 3,
//                             boxShadow: 4,
//                             overflow: "hidden",
//                             height: "350px"
//                         }}
//                     >
//                         <CardMedia
//                             component="img"
//                             image="/images/social.jpg"
//                             alt="Social Responsibility"
//                             sx={{ height: { xs: 250, md: "100%" }, objectFit: "cover" }}
//                         />
//                     </Card>
//                 </Grid>

//                 {/* Right Content */}
//                 <Grid item xs={12} md={7} sx={{ width: "60%", textAlign: "justify" }}>
//                     {socialresponsibility &&
//                         socialresponsibility.map((data, index) => (
//                             <Box key={index} sx={{ mb: 3 }}>
//                                 {Array.isArray(data) ? (
//                                     <>
//                                         <Typography
//                                             variant="h6"
//                                             sx={{
//                                                 color: "#030366",
//                                                 fontWeight: "bold",
//                                                 mb: 1,
//                                             }}
//                                         >
//                                             Environment
//                                         </Typography>
//                                         {data.map((subItem, subIndex) => (
//                                             <Typography
//                                                 key={subIndex}
//                                                 variant="body1"
//                                                 sx={{
//                                                     fontFamily: "Raleway, sans-serif",
//                                                     mb: 1,
//                                                 }}
//                                             >
//                                                 {subItem}
//                                             </Typography>
//                                         ))}
//                                     </>
//                                 ) : (
//                                     <Typography
//                                         variant="body1"
//                                         sx={{ fontFamily: "Raleway, sans-serif", mb: 2 }}
//                                     >
//                                         {data}
//                                     </Typography>
//                                 )}
//                             </Box>
//                         ))}
//                 </Grid>
//             </Grid>
//         </Container>
//     );
// }

// export default SocialResponsibility;
